<template>
  <kst-container class="kst-purchase-edit">
    <ValidationObserver ref="formDetails">
      <kst-form submit
        :cancelUrl="cancelUrl"
        :loading="isLoading"
        :title="title"
        :errors="errors"
        :failure="failure"
        :failureInit="failureInit"
        :hide-body="!!formWarnings"
        :hide-footer="!!formWarnings"
        :warnings="formWarnings"
        @submit="handleFormSubmit"
      >
        <Details :userData="userData" :warehouseOptions="warehouseOptions"/>
        <Items :userData="userData" :userItems="userItems"/>
        <Total :data="userData"/>
      </kst-form>
    </ValidationObserver>
  </kst-container>
</template>

<script>
import AxiosMixin from "@/mixins/AxiosMixin.js";
import RouterMixin from "@/mixins/RouterMixin.js";
import InputPageMixin from "@/mixins/InputPageMixin.js";
import LoadingMixin from "@/mixins/LoadingMixin.js";
import SnackbarMixin from "@/mixins/SnackbarMixin.js";
import Router from "../PurchaseRouter.js";
import Model from "../PurchaseModel.js";
import Info from "../PurchaseInfo.js";

import Details from "./PurchaseEdit_Details";
import Items from "./PurchaseEdit_Items";
import Total from "./PurchaseEdit_Total";

import Services from "../PurchaseServices.js";

export default {
  components: {
    Details,
    Items,
    Total
  },
  mixins: [AxiosMixin, RouterMixin, InputPageMixin, LoadingMixin, SnackbarMixin],
  data: () => ({
    userData: {},
    userItems: [],
    isLoading: true,
    warehouseOptions: {},
    cancelUrl: Router.Path.List,
    saveLoading: null,
    // error
    errors: null,
    formWarnings: null,
    failure: null,
    failureInit: null
  }),
  computed: {
    title() {
      return this.$route.meta.title;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.failureInit = null;

      const id = this.getUrlParam(this.$kst.Enum.Param.ID);
      this.formWarnings = null;

      if (!id) {
        this.formWarnings = [Info.Message.Edit_ParamIncomplete];
        return;
      }
      this.userData = Model.createDetails();
      this.userData.IsAutoNumber = false;
      this.loadDetails(id);
      this.loadWarehouse();
    },
    initLoad_End() {
      this.isLoading = false;
    },

    loadWarehouse() {
      let options = {}
      options.active = Model.IsActive.Active.ID

      const config = Services.getWarehouseList(options);
      this.runAxios(config, null, this.loadWarehouse_Success, this.loadWarehouse_Error);
    },
    loadWarehouse_Success(data) {
      this.warehouseOptions = Model.getWarehouseOptions(data);
    },
    loadWarehouse_Error(message) {
      this.failureInit = message;
    },

    loadDetails(id) {
      const options = { withpackagings: 1, withreceiving: 1, withreceivingcount: 1 };
      const config = Services.getPurchaseDetails(id, options);
      this.runAxios(config, null, this.loadDetails_Success, this.loadDetails_Error);
    },
    loadDetails_Success(data) {
      Model.setDetailsByData(this.userData, data);

      for (const items of data.Items) {
        let item = Model.createItem();
        Model.setItemByData(item, items);
        this.userItems.push(item);
      }
      
      Model.updateDetails(this.userData, this.userItems);
      this.initLoad_End();
    },
    loadDetails_Error(message) {
      this.failureInit = message;
      this.initLoad_End();
    },

    handleFormSubmit() {
      this.saveLoading = null;
      this.$refs.formDetails.validate().then(isValid => {
        if (isValid) {
          let data = Model.populateData(this.userData, this.userItems);
          this.saveData(data);
        }
        else {
          this.notifyFormError();
        }
      });
    },

    saveData(data) {
      this.errors = null;
      this.failure = null;
      this.saveLoading = this.openLoading();

      const config = Services.putPurchase(data);
      this.runAxios(config, null,
        this.saveData_Success,
        this.saveData_Error,
        this.saveData_Invalid
      );
    },
    saveData_End() {
      this.closeLoading(this.saveLoading);
    },
    saveData_Success(data) {
      this.saveData_End();
      this.routeLeaveEnabled = false;

      this.notifyFormSuccess(() => {
        const urlParams = this.$kst.Route.getParams({
          [this.$kst.Enum.Param.ID]: data.id
        });
        this.redirectTo(Router.Path.Details + urlParams);
      });
    },
    saveData_Error(message) {
      this.failure = message;
      this.saveData_End();
    },
    saveData_Invalid(message) {
      this.errors = [message];
      this.saveData_End();
      this.notifyFormError();
    }

  }
}
</script>